'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkTabItem.module.css';

export function DevlinkTabItem({ as: _Component = _Builtin.Block, tabLabel = 'Home Theater', tabAction = {} }) {
  return (
    <_Component className={_utils.cx(_styles, 'ht-tab-item')} tag="div" {...tabAction}>
      <_Builtin.Block className={_utils.cx(_styles, 'no-wrap')} tag="div">
        {tabLabel}
      </_Builtin.Block>
    </_Component>
  );
}
